import { z } from 'zod';
import { ProductIdSchema } from './products';
import { UserIdSchema } from './users';
import { NumericalIdSchema } from './commonTypes';
export var GoalSchema = z.object({
    id: NumericalIdSchema,
    product_id: ProductIdSchema,
    user_id: UserIdSchema,
    goal: z.coerce.number(),
    goal_frequency: z.coerce.number(),
    value_goal: z.coerce.number(),
    value_goal_frequency: z.coerce.number(),
    deactivated: z.coerce.boolean(),
    add_time: z.string(),
    update_time: z.string(),
    quantity_start_date: z.string().nullable(),
    value_start_date: z.string().nullable(),
    activity: z.object({
        quantity: z.number(),
        value: z.number()
    })
});
export var GoalUpdateSchema = GoalSchema.pick({
    goal_frequency: true,
    goal: true,
    user_id: true,
    product_id: true
});
